module.exports = __webpack_public_path__ + "img/logo.7b1bc8f1.png";